import React, { Component } from 'react'
import { connect } from "react-redux"
import trans from "trans"

import { Template, Palette, AlternativeTemplate } from "app/types/model-types"
import { RandomProduct } from 'shape-edit/types'

import {
    css,
    Button,
    Grid,
    GridCell,
    Icon,
    Theme,
    modal,
} from "@bdfx/mergado-ui-kit"

import { updateInputValue as change } from "app/reducers/form"

import TransparentColor from 'shape-edit/forms/transparent-color'
import ImportColorsFromPaletteModal from './import-colors-from-palette-modal';
import { selectFormValues } from 'app/reducers/form'
import { getFormName } from 'shape-edit/forms/helpers'
import { TemplateOrAlternativeTemplateType } from 'template-edit/undoRedoReducers'

interface Props {
    randomProduct: RandomProduct
    isAlt: boolean
    form: TemplateOrAlternativeTemplateType
    palettes: Palette[]
    customPalettes: Palette[]
    change: typeof change
}

interface State {
    colors: string[]
    currentIndex: number,
}

class MultiColorSelect extends Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            currentIndex: 0,
            colors: this.backgroundColorsFromProps(props),
        }
    }

    backgroundColorsFromProps = (props): string[] => {
        return (props.form?.background_colors) ? [...(props.form.background_colors.split(',').filter(c => !!c && c !== '')), ''] : ['']
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
        if (prevProps && prevProps.form && prevProps.form.background_colors && prevProps.form.background_colors !== this.props.form.background_colors) {
            this.setState({ colors: this.backgroundColorsFromProps(this.props) })
        }
    }

    handleDeleteColorIndex = (deleteIdx: number) => {
        const { colors } = this.state
        const { isAlt } = this.props
        const formName = getFormName(isAlt)

        const updatedColors = colors.filter((color, idx) => idx !== deleteIdx)
        this.setState({ colors: updatedColors })
        this.props.change(formName, 'background_colors', updatedColors.join(','))
    }

    addColors = (addColors: string[]) => {
        const { isAlt } = this.props
        const formName = getFormName(isAlt)
        const updatedColors = [...this.state.colors, ...addColors]
        this.setState({ colors: updatedColors })
        this.props.change(formName, 'background_colors', updatedColors.join(','))
    }

    showImportPaletteModal = () => {
        const { palettes, customPalettes, randomProduct } = this.props
        modal({
            overlayClassName: 'import-palette-colors-modal',
            title: trans("import_palette"),
            message: (close) => <ImportColorsFromPaletteModal
                close={close}
                addColors={this.addColors}
                palettes={palettes}
                customPalettes={customPalettes}
                randomProductColors={randomProduct.palette}
            />,
            closeOnEscape: true,
            closeOnClickOutside: true,
            hideCloseButton: false,
        })
    }

    render() {
        const { currentIndex, colors } = this.state
        const { isAlt } = this.props
        const formName = getFormName(isAlt)

        return (
            <StyledDiv>
                <StyledGrid cols={`repeat(auto-fit, minmax(180px, auto))`}>
                    {colors.map((color, index) =>
                        <GridCell key={`color_${index}`}>

                            {/* <Grid cols={'auto auto'}>
                                <GridCell style={{ background: color }}> */}

                            <TransparentColor
                                value={color}
                                hideGradients={true}
                                changeValue={(color) => {
                                    let updatedColors = [...colors]
                                    updatedColors[index] = color
                                    this.setState({ colors: updatedColors })
                                    const backgroundColors = updatedColors.filter(color => !!color && color !== '').join(',')
                                    this.props.change(formName, 'background_colors', backgroundColors)
                                }}
                            />

                            {/* </GridCell>
                                <GridCell className={'clickable'} onClick={() => this.handleDeleteColorIndex(index)} title={trans('delete')}>
                                    <Icon type={'trash'} size={14} color={Theme.red} />
                                </GridCell>
                            </Grid> */}

                        </GridCell>
                    )}
                </StyledGrid>

                <BackgroundColorsButtonsGrid cols={'repeat(3, auto)'}>
                    <GridCell>
                        <Button
                            color={'nocolor'}
                            type={'void'}
                            icon={<Icon type={'plus'} size={18} />}
                            onClick={() => this.setState({
                                currentIndex: currentIndex + 1,
                                colors: [...colors, '']
                            })}>
                            {trans('add_color')}
                        </Button>
                    </GridCell>
                    <GridCell>
                        <Button
                            color={'nocolor'}
                            type={'void'}
                            icon={<Icon type={'plus'} size={18} />}
                            onClick={(e) => this.showImportPaletteModal()}>
                            {trans('import_palette')}
                        </Button>
                    </GridCell>
                    <GridCell>
                        <Button
                            color={'nocolor'}
                            type={'void'}
                            icon={<Icon type={'trash-o'} size={18} />}
                            onClick={() => {
                                this.setState({ colors: [''] })
                                this.props.change(formName, 'background_colors', null)
                            }}>
                            {trans('delete_palette')}
                        </Button>
                    </GridCell>
                </BackgroundColorsButtonsGrid>

            </StyledDiv>
        )
    }
}

const StyledDiv = css("div")({
})

const BackgroundColorsButtonsGrid = css(Grid)({
    marginTop: '15px',
    ' .muk-gridcell': {
        alignSelf: 'center',
        textAlign: 'center',
    }
})

const StyledGrid = css(Grid)({
    gridGap: '5px',
    ' .muk-gridcell': {
        alignSelf: 'center',
        textAlign: 'center',
    },
})

function mapStateToProps(state) {
    return {
        isAlt: state.isAlt,
        form: selectFormValues(state, getFormName(state.isAlt)),
        palettes: state.palettes,
        customPalettes: selectFormValues(state, 'customPalettesForm').palettes,
        randomProduct: state.randomProduct,
    }
}

export default connect(mapStateToProps, {
    change,
})(MultiColorSelect)
